import React from "react";
import { HexColorPicker } from "react-colorful";
import { makeStyles } from "@material-ui/core";
import { useTranslation } from "react-i18next";

import useClickOutside from "./useClickOutside";

const useStyles = makeStyles({
  picker: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    marginTop: 5,
    marginBottom: 5,
  },
  swatch: {
    width: 25,
    height: 25,
    borderRadius: 8,
    border: "3px solid #fff",
    boxShadow:
      "0 0 0 1px rgba(0, 0, 0, 0.1), inset 0 0 0 1px rgba(0, 0, 0, 0.1)",
    cursor: "pointer",
  },
  popover: {
    position: "absolute",
    top: "calc(100% + 2px)",
    left: 0,
    borderRadius: 9,
    boxShadow: "0 6px 12px rgba(0, 0, 0, 0.15)",
    zIndex: 2,
  },
  text: {
    margin: 0,
    marginRight: 20,
  },
});

export const ColorPicker = ({ color, onChange, title }) => {
  const classes = useStyles();
  const popover = React.useRef();
  const [isOpen, toggle] = React.useState(false);
  const { t } = useTranslation();

  const close = React.useCallback(() => toggle(false), []);
  useClickOutside(popover, close);

  return (
    <div className={classes.picker}>
      <p className={classes.text}>
        {title}: {"   "}
      </p>
      <div
        className={classes.swatch}
        style={{ backgroundColor: color }}
        onClick={() => toggle(true)}
      />
      {isOpen && (
        <div className={classes.popover} ref={popover}>
          <HexColorPicker color={color} onChange={onChange} />
        </div>
      )}
    </div>
  );
};
